import { useTranslation } from "react-i18next";
import { TABLE_HEADERS } from "../constants";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { AlertColor } from "@mui/material";
import CustomizedSnackbars from "../../../components/common/customizedSnackbars";
import { ROUTES } from "../../../setup/constants";
import StatusPill from "../../cashouts/CashoutCard/StatusPill";
import { IWithdrawBody } from "../../../setup/api/services/withdraws/models";

interface IWithdrawsListItem {
  request: IWithdrawBody;
}

const WithdrawsListItem = ({ request }: IWithdrawsListItem) => {
  const { t } = useTranslation();

  const [snackBarOpen, setSnackBarOpen] = useState<boolean>(false);
  const [snackBarColor, setSnackBarColor] = useState<AlertColor>("info");
  const [snackBarTitle, setSnackBarTitle] = useState<string>("");

  const createRow = (desc: string, value) => {
    return { desc, value };
  };

  const handleRowClick = () => {
    window.open(`${ROUTES.WITHDRAWS}/${request.id}`, "_blank");
  };

  const getDate = (date) => {
    // Format date part
    const datePart = new Intl.DateTimeFormat("ar-EG-u-nu-latn", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(date);

    // Format time part with AM/PM detection
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const period = hours < 12 ? "صباحًا" : "مساءً";

    if (hours === 0) {
      hours = 12; // midnight
    } else if (hours > 12) {
      hours -= 12; // convert to 12-hour format
    }

    const timePart = `${hours}:${minutes} ${period}`;

    // Final output
    return `${datePart} - ${timePart}`;
  };

  const rows = [
    createRow(
      TABLE_HEADERS.USER_NAME,
      <div className={styles["request_cell"]} onClick={handleRowClick}>
        <p dir="rtl">{request.beneficiaryName || ""}</p>
      </div>
    ),
    createRow(
      TABLE_HEADERS.REQUEST_TIME,
      <div className={styles["request_date"]}>
        <p dir="rtl">{getDate(new Date(request.createdAt))}</p>
      </div>
    ),
    createRow(
      TABLE_HEADERS.AMOUNT,
      <div className={styles["request_bold"]}>
        <p dir="rtl">
          {request.amount.toFixed(2) + " " + t("lbl_saudi_currency")}
        </p>
      </div>
    ),
    createRow(
      TABLE_HEADERS.STATUS,
      <div className={styles["request_status"]}>
        <StatusPill status={request.status} />

        <img
          src="/assets/images/svg/arrow2.svg"
          alt="تفاصيل"
          onClick={handleRowClick}
        />
      </div>
    ),
  ];

  useEffect(() => {
    if (snackBarOpen) {
      setTimeout(() => {
        setSnackBarOpen(false);
        setSnackBarColor("info");
        setSnackBarTitle("");
      }, 5000);
    }
  }, [snackBarOpen]);

  const renderSnackBar = () => {
    return snackBarOpen ? (
      <CustomizedSnackbars
        open={snackBarOpen}
        title={snackBarTitle}
        type={snackBarColor}
      />
    ) : null;
  };

  return (
    <>
      <tr className={styles.table_row}>
        {rows.map((row, index) => (
          <td className={styles.table_value} key={index}>
            {row.value}
          </td>
        ))}
      </tr>
      <div className={styles.snackbar}>{renderSnackBar()}</div>
    </>
  );
};

export default WithdrawsListItem;
